import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Link } from '@inertiajs/react';

export default function SimilarFacilities({ facilities = [], currentFilters = {} }) {
  // If no facilities, don't render
  if (!facilities || facilities.length === 0) return null;
  
  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-gray-900">Similar Communities</h3>
      
      <div className="grid grid-cols-1 gap-4">
        {facilities.map((facility) => (
          <Link 
            key={facility.id} 
            href={`/facilities/${facility.slug}`}
            data={{ ...currentFilters }}
            preserveState
            only={['facility']}
            className="block"
          >
            <Card className="overflow-hidden transition-all hover:shadow-md">
              <div className="flex flex-col sm:flex-row">
                {/* Facility image */}
                <div className="w-full sm:w-40 h-32 sm:h-auto overflow-hidden">
                  <img
                    src={facility.image || "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"}
                    alt={facility.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Facility details */}
                <CardContent className="flex-1 p-4">
                  <h4 className="font-medium text-lg">{facility.name}</h4>
                  <p className="text-sm text-gray-600 mb-2">{facility.address}</p>
                  
                  {/* Care types */}
                  {facility.types && facility.types.length > 0 && (
                    <div className="flex flex-wrap gap-1 mb-2">
                      {facility.types.map((type, index) => (
                        <Badge key={index} variant="outline" className="text-xs bg-blue-50 text-blue-700 border-blue-200">
                          {type}
                        </Badge>
                      ))}
                    </div>
                  )}
                  
                  {/* Price and ratings */}
                  <div className="flex justify-between items-center mt-2">
                    {facility.cost ? (
                      <div className="text-sm">
                        <span className="text-gray-500">Starting at </span>
                        <span className="font-semibold text-blue-700">${facility.cost.toLocaleString()}</span>
                      </div>
                    ) : (
                      <div className="text-sm text-gray-500">Contact for pricing</div>
                    )}
                    
                    {facility.ratings && (
                      <div className="flex items-center">
                        <div className="flex text-yellow-400 mr-1">
                          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                        </div>
                        <span className="text-sm font-medium">
                          {((facility.ratings.food + facility.ratings.care + facility.ratings.cleanliness) / 3).toFixed(1)}
                        </span>
                      </div>
                    )}
                  </div>
                </CardContent>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
